/* eslint-disable no-return-assign */
import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import FocusLock from 'react-focus-lock';


const Portal = ({ children, rootId, onClose, parent, className }) => {
  const mount = document.getElementById(rootId);
  const el = document.createElement('div');
  const rect = mount.getBoundingClientRect();
  const { pageYOffset } = window;

  const top = rect.top + pageYOffset + 40;

  const modalRef = useRef(null);
  useEffect(() => {
    document.body.appendChild(el);
    return () => document.body.removeChild(el);
  }, [el]);

  useEffect(() => {
    function handleResize() {
      onClose();
    }
    const handleClickOutside = e => {
      if (modalRef.current.contains(e.target) || parent.contains(e.target)) {
        return;
      }

      onClose(false);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('mousedown', handleClickOutside);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose, parent]);
  return createPortal(
    <div
      aria-modal="true"
      ref={modalRef}
      className={className}
      tabIndex="-1"
      style={{
        position: 'absolute',
        top: `${top}px`,
        left: `${rect.left}px`,
        width: '21.5rem'
      }}
    >
      <FocusLock>
        <div>{children}</div>
        <div className="inline-modal-actions sr-only">
          <button type="button" className="fn-btn" aria-labelledby="close-modal" onClick={onClose}>
            Close
            <svg viewBox="0 0 40 40" className="c-modal__close-icon">
              <path d="M 10,10 L 30,30 M 30,10 L 10,30"></path>
            </svg>
          </button>
        </div>
      </FocusLock>
    </div>,
    el
  );
};

export default Portal;
